import { render, staticRenderFns } from "./evaluated-inactive.component.html?vue&type=template&id=2232a9fe&scoped=true&external"
import script from "./evaluated-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./evaluated-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./evaluated-inactive.component.scss?vue&type=style&index=0&id=2232a9fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232a9fe",
  null
  
)

export default component.exports